import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import * as React from 'react';
import { BodyText } from 'palette/Typography';
import './styles/SubHeaderDropdownSection.scss';

interface SubHeaderDropdownSectionProps {
    children: React.ReactNode;
    className: string;
    splitColumns: boolean;
    name?: string;
    isLastSection?: boolean;
    v2?: boolean;
}

function SubHeaderDropdownSection({
    children,
    name,
    className,
    splitColumns,
    isLastSection,
    v2,
} : SubHeaderDropdownSectionProps) {
    const blockName = v2 ? 'subheader-dropdown-section-v2' : 'subheader-dropdown-section';
    const [block, BEMElement] = BEMBlock(blockName, { last: isLastSection, 'split-columns': splitColumns });
    const blockClasses = classNames(block, className);

    return (
        <div className={blockClasses}>
            {name ? (
                <BodyText
                    className={BEMElement('title')}
                    level="1"
                >
                    {name}
                </BodyText>
            ) : null}
            <ul className={BEMElement('list', { 'split-columns': splitColumns })}>
                {children}
            </ul>
        </div>
    );
}

export default SubHeaderDropdownSection;
